import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { Table } from '@tanstack/react-table';
import { noop } from 'lodash';

import { useAppSelector } from 'src/app/store/hooks';
import {
  TripListRead,
  TripRead,
} from 'src/common/external/bambi-api/tripsApi';
import { IndeterminateCheckbox } from 'src/common/primitives/IndeterminateCheckbox';

import { selectHasActiveTripFilters } from '../../trip.slice';

const NO_FILTERS_TOOLTIP = 'Apply a filter to select all trips on this page.';

export function TripSelectAllHeader({
  table,
}: {
  table: Table<TripListRead | TripRead>;
}) {
  const hasFilters = useAppSelector(selectHasActiveTripFilters);

  const disabled = !hasFilters;
  const tooltip = disabled ? NO_FILTERS_TOOLTIP : null;

  const allSelected = !disabled && table.getIsAllRowsSelected();
  const someSelected = !disabled && table.getIsSomeRowsSelected();

  // The span wraps the checkbox so hover/focus events reach the tooltip even
  // when the underlying Radix checkbox is `disabled` (which kills its own
  // pointer events).
  const trigger = (
    <span
      data-testid={
        disabled ? 'select-all-trips-disabled' : 'select-all-trips-checkbox'
      }
    >
      <IndeterminateCheckbox
        checked={allSelected}
        indeterminate={someSelected && !allSelected}
        onChange={disabled ? noop : () => table.toggleAllRowsSelected()}
        disabled={disabled}
      />
    </span>
  );

  return (
    <div data-testid="row-selection-column">
      {tooltip ? (
        <SimpleTooltip trigger={trigger} content={tooltip} />
      ) : (
        trigger
      )}
    </div>
  );
}
